import { render } from "./Widget14.vue?vue&type=template&id=a164f4a4&ts=true"
import script from "./Widget14.vue?vue&type=script&lang=ts"
export * from "./Widget14.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__